import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=ae621d76&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./forget.vue?vue&type=style&index=0&id=ae621d76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae621d76",
  null
  
)

export default component.exports